<template>
  <main class="main page-inside payment-result-page">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="title big">{{ $t('Offer sent successfully') }}</div>
          <div class="desc">{{ $t('We will contact you by e-mail within 48 hours.') }}</div>
          <div class="buttons">
            <router-link to="/sell-offers" class="button">
              <span>{{ $t('Back to my offers') }}</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'OfferSuccessPage',
};
</script>

<style scoped>
.buttons {
  margin-top: 32px;
  display: flex;
  gap: 16px;
  justify-content: center;
  align-items: center;
}

.button {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 14px 28px;
  text-transform: uppercase;
}
</style>
